import { render, staticRenderFns } from "./IncomeOutcome.vue?vue&type=template&id=2e0c50a6&"
import script from "./IncomeOutcome.vue?vue&type=script&lang=js&"
export * from "./IncomeOutcome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports